<template>
    <div class="doughnut section card card--white doughnut-card">
      <div class="card--container doughnut-container">
          <div class="section-headers"><slot>General Well Being</slot></div>
          <doughnut :chartData="info" :options="options" class="doughnut-chart"/>
          <div class="description">{{word}}</div>
    </div>
  </div>
</template>

<script type="text/javascript">
import doughnut from "./doughnut";
export default {
  props: ['total'],
  components: { doughnut },
  data() {
    return {
      options: {
        cutoutPercentage: 80,
        circumference:  Math.PI * 1.5,
        rotation: Math.PI * .75
      }
    }
  },
  computed: {
    word() {
      if (this.total > .9) {
        return 'Great';
      } else if (this.total > .7) {
        return 'Good';
      } else if (this.total > .5) {
        return 'So-So';
      } else if (this.total > 0) {
        return 'Struggling'
      }
      return "N/A";

    },
    color() {
      if (this.total > .9) {
        return 'purle';
      } else if (this.total > .7) {
        return 'blue';
      } else if (this.total > .5) {
        return 'orange';
      }
      return 'red'
    },
    info() {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      // Create a linear gradient
      // The start gradient point is at x=20, y=0
      // The end gradient point is at x=220, y=0
      var gradient = ctx.createLinearGradient(0, 0, 300, 0);

      // Add three color stops
      gradient.addColorStop(0, 'red');
      gradient.addColorStop(.8, 'blue');

      // Set the fill style and draw a rectangle
      return {
        datasets: [{
          data: [this.total, 1 - this.total],
          backgroundColor: [gradient, 'gray']
        }]
      }
    }
  }
}

</script>

<style lang="less" scoped>
.doughnut {
  margin-left: 8px;
  margin-right: 8px;
  width: 100%;
  .doughnut-card {
    min-width: 100%;
  }
  .doughnut-container {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .description {
      margin-top: -20px;
      font-size: 20px;
      text-transform: uppercase;
      opacity: .7;
      font-weight: 600;
    }

    .doughnut-chart {
      max-height: 200px;
      max-width: 200px;
    }
  }

  @media (max-width: 440px) {
    .doughnut {
      margin-left: 3px;
      margin-right: 3px;
    }
    .doughnut-container {
      max-width: 100%;
      }

    }
}

</style>
